import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';

import {
    TABLE_ROWS_KEYS as INDIVIDUAL_ROWS_KEYS,
    TABLE_ROWS_NAMES as INDIVIDUAL_ROWS_NAMES
} from '@app/teacher/components/analysis/analysis-list-subject-home/individual-data/individual.constants';
import {
    TABLE_ROWS_KEYS as SUMMARY_ROWS_KEYS,
    TABLE_ROWS_NAMES as SUMMARY_ROWS_NAMES
} from '@app/teacher/components/analysis/analysis-list-subject-home/summary-data/summary.constants';

@Component({
    selector: 'app-individual-or-summary-data-modal',
    templateUrl: './individual-data-modal.component.html',
    styleUrls: ['./individual-data-modal.component.scss']
})
export class IndividualOrSummaryDataModalComponent implements OnInit {
    public selectedTableRows: Array<string> = [];
    tableRows: Array<string> = [];

    @Input() summaryOrIndividual: string;
    @Input() data: Array<string>;

    @Output() closeBtnClicked: EventEmitter<boolean> = new EventEmitter();
    @Output() choseTableRows: EventEmitter<Array<string>> = new EventEmitter();

    constructor() {}

    ngOnInit() {
        if (this.summaryOrIndividual === 'summary') {
            this.tableRows = SUMMARY_ROWS_KEYS;
        } else {
            this.tableRows = INDIVIDUAL_ROWS_KEYS;
        }

        this.selectedTableRows = this.data.slice();
    }

    close() {
        this.closeBtnClicked.emit(true);
    }

    save() {
        this.choseTableRows.emit(this.selectedTableRows);
        this.close();
    }

    isRowSelected(row) {
        return this.selectedTableRows.indexOf(row) > -1;
    }

    getRowName(row: string) {
        if (this.summaryOrIndividual === 'summary') {
            return SUMMARY_ROWS_NAMES[row] || '';
        } else {
            return INDIVIDUAL_ROWS_NAMES[row] || '';
        }
    }

    moveUp(idx: number) {
        if (idx === 0) {
            return;
        }

        const e = this.selectedTableRows.splice(idx - 1, 1);
        this.selectedTableRows.splice(idx, 0, ...e);
    }

    moveDown(idx: number) {
        if (idx === this.selectedTableRows.length - 1) {
            return;
        }
        this.moveUp(idx + 1);
    }

    remove(idx: number) {
        this.selectedTableRows.splice(idx, 1);
    }

    add(row: string) {
        if (this.selectedTableRows.indexOf(row) !== -1) {
            return;
        }
        this.selectedTableRows.push(row);
    }
}
